export const copy = Object.freeze({
  "owner.device.available": "Available",
  "owner.device.reconnecting": "Reconnecting...",
  "owner.device.backgroundLimited":
    "Availability may be limited while this app is in the background",
  "owner.device.unavailable": "Sharing is unavailable right now",
  "share.draft": "Draft",
  "share.preparing": "Preparing...",
  "share.available": "Available",
  "share.active": "Active",
  "share.paused": "Paused",
  "share.needsPhotos": "Choose photos again",
  "share.expired": "Expired",
  "share.revoked": "Revoked",
  "viewer.admission.authorizing": "Checking your invitation...",
  "viewer.admission.waitingForOwner":
    "Waiting for this share to become available",
  "viewer.admission.waitingForCapacity": "You're next",
  "viewer.admission.connecting": "Opening your share...",
  "viewer.admission.reconnecting": "Reconnecting...",
  "viewer.admission.unavailable": "This share is unavailable right now",
  "viewer.activity.ready": "Ready",
  "viewer.activity.browsing": "Browsing",
  "viewer.activity.downloadingOriginal": "Downloading original...",
  "transfer.queued": "Download queued",
  "transfer.starting": "Starting download...",
  "transfer.transferring": "Downloading original...",
  "transfer.verifying": "Finishing download...",
  "transfer.completed": "Download complete",
  "transfer.cancelled": "Download cancelled",
  "transfer.failed": "Download interrupted",
  "video.detail": "Original video. Download to watch.",
  "video.disabledDuringSession":
    "Video downloads are unavailable now. Your photos are still available.",
  "action.downloadOriginal": "Download original",
  "action.requestAccess": "Request access",
  "action.accessRequested": "Access requested",
  "action.cancel": "Cancel",
  "action.tryAgain": "Try again",
  "action.backToPhotos": "Back to photos",
  "action.otherShares": "Other shares",
  "action.close": "Close",
} as const);

export type CopyKey = keyof typeof copy;

export function getCopy(key: CopyKey): string {
  return copy[key];
}
